import {
  CLOSEAUTHOR,
  CLOSECATEGORY,
  GETAUTHOR,
  GETCATEGORY,
} from "./ActionType";

export const getAuthor = (authorName) => {
  return {
    type: GETAUTHOR,
    payload: authorName,
  };
};

export const getCategory = (category) => {
  return {
    type: GETCATEGORY,
    payload: category,
  };
};
export const closeCategory = () => {
  return {
    type: CLOSECATEGORY,
  };
};
export const closeAuthor = () => {
  return {
    type: CLOSEAUTHOR,
  };
};
